import { IS_LOCAL } from '@/helpers';
import i18n from '@/plugins/i18n';

/**
 * @description 에러 모달 오픈
 */
function openErrModal(errModal, e) {
  console.error(e);

  errModal.open({
    // 오류가 발생했습니다.
    title: e.response?.data?.message?.title ?? i18n.t('etc.modalerr'),
    content: e.response?.data?.message?.content ?? e.response?.data?.message?.replaceAll('|', '<br />') ?? e,
    cancel: false,
  });
}

const DalgonaStore = {
  namespaced: true,
  state() {
    return {
      /** 데일리 미션 상태 */
      dailyMissionStatus: {
        attendance: 1,
        invite: 0,
        subs: 0,
        rentalIncome: 0,
        swap: 0,
        nft: 0,
      },
      /** 달고나 게임 상태 */
      dalgonaGameStatus: {
        isOngoing: false, // 게임 진행 중인지
        coin: 0, // 내가 모은 동전
        shape: null, // 진행 중인 달고나 모양
        angle: null,
      },
      /** 달고나 세트 상태 */
      dalgonaSetStatus: {},
      /** 달고나 세트 상세 내역 */
      dalgonaSetDetail: [],
    };
  },
  getters: {},
  mutations: {
    setDailyMissionStatus(state, status) {
      state.dailyMissionStatus = { ...status };
      state.dailyMissionStatus.attendance = 1;
    },
    setDalgonaGameStatus(state, status) {
      state.dalgonaGameStatus = { ...status };
    },
    setDalgonaSetStatus(state, status) {
      state.dalgonaSetStatus = { ...status };
    },
    setDalgonaSetDetail(state, detail) {
      state.dalgonaSetDetail = detail;
    },
  },
  actions: {
    /**
     * @description API 호출
     */
    async fetch({ rootState: { vm, globalErrorModal } }, { url, method, params }) {
      const data = method === 'get' ? { params: { ...params } } : params;

      try {
        const { data: responseData } = await this._vm.$axios[method](
          `${process.env.VUE_APP_TEST_SERVER}${'/dalgona' + url}`,
          data
        );
        return responseData;
      } catch (e) {
        if (e?.response?.status === 401) vm.$bvModal.show('login-required');
        else openErrModal(globalErrorModal, e);

        throw e;
      }
    },
    /**
     * @description 달고나 게임 미션 현황 조회
     */
    async getDailyMissionStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          attendance: 1,
          invite: 1,
          subs: 3,
          rentalIncome: 0,
          swap: 1,
          nft: 1,
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/mission/status',
      });

      return response;
    },
    /**
     * @description 달고나 게임 미션 현황 업데이트
     */
    async fetchDailyMissionStatus({ dispatch, commit }) {
      console.log('fetchDailyMissionStatus');
      const missionStatus = await dispatch('getDailyMissionStatus');

      commit('setDailyMissionStatus', missionStatus);
      return;
    },
    /**
     * @description 달고나 게임 상태 조회
     */
    async getDalgonaGameStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          isOngoing: false,
          coin: 25,
          shape: null,
          angle: null,
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/game/status',
      });

      return response;
    },
    /**
     * @description 달고나 게임 상태 업데이트
     */
    async fetchDalgonaGameStatus({ dispatch, commit }) {
      console.log('fetchDalgonaGameStatus');
      const gameStatus = await dispatch('getDalgonaGameStatus');

      commit('setDalgonaGameStatus', gameStatus);
      return;
    },
    /**
     * @description 달고나 세트 상태 조회
     */
    async getDalgonaSetStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          status: [1, 2, 1, 4], // circle, triangle, star, umbrella 순서
          completed: 2, // 나의 완성 세트 수
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/set/status',
      });

      return response;
    },
    /**
     * @description 달고나 세트 상태 업데이트
     */
    async fetchDalgonaSetStatus({ dispatch, commit }) {
      console.log('fetchDalgonaSetStatus');
      const setStatus = await dispatch('getDalgonaSetStatus');

      commit('setDalgonaSetStatus', setStatus);
      return;
    },
    /**
     * @description 달고나 세트 상세 내역 조회
     */
    async getDalgonaSetDetail({ dispatch }) {
      if (IS_LOCAL) {
        return [
          {
            date: '2024-03-22T17:34:23',
            content: '출석체크 완료',
            value: 1,
          },
        ];
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/set/history',
      });

      return response;
    },
    /**
     * @description 달고나 세트 상세 내역 업데이트
     */
    async fetchDalgonaSetDetail({ dispatch, commit }) {
      console.log('fetchDalgonaSetDetail');
      const setDetail = await dispatch('getDalgonaSetDetail');

      commit('setDalgonaSetDetail', setDetail);
      return;
    },
    /**
     * @description 달고나 모양 뽑기
     */
    async postDalgonaShape({ dispatch }, { isRetry }) {
      if (IS_LOCAL) {
        return {
          isOngoing: true, // 게임 진행 중인지
          coin: 24, // 내가 모은 동전
          shape: 'umbrella', // 진행 중인 달고나 모양
          angle: 5, // 0, 90, 180, 270
        };
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: '/game/play',
        params: {
          isRetry: isRetry,
        },
      });

      return response;
    },
    /**
     * @description 달고나 모양 뽑기
     */
    async submitDalgonaShape({ dispatch }, { isRetry }) {
      console.log('submitDalgonaShape');
      const result = await dispatch('postDalgonaShape', { isRetry });

      return result;
    },
    /**
     * @description 달고나 게임 결과 보내기
     */
    async postDalgonaResult({ dispatch }, { angle }) {
      if (IS_LOCAL) {
        return {
          result: 'success',
        };
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: '/game/result',
        params: {
          pickAngle: angle,
        },
      });

      return response;
    },
    /**
     * @description 달고나 게임 결과 보내기
     */
    async submitDalgonaResult({ dispatch }, { angle }) {
      console.log('submitDalgonaResult');
      const result = await dispatch('postDalgonaResult', { angle });

      return result;
    },
    /**
     * @description 달고나 세트 보상 받기
     */
    async postDalgonaSetReward({ dispatch }) {
      if (IS_LOCAL) {
        return '';
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: '/set/reward',
      });

      return response;
    },
    /**
     * @description 달고나 세트 보상 받기
     */
    async submitDalgonaSetReward({ dispatch }) {
      console.log('submitDalgonaSetReward');
      const result = await dispatch('postDalgonaSetReward');

      return result;
    },
  },
};

export default DalgonaStore;
